import { animate, style, transition, trigger } from '@angular/animations';

export const navigationAnimation = trigger('routeAnimations', [
  transition('* => *', [style({ opacity: 0 }), animate('500ms ease-in', style({ opacity: 1 }))])
]);
